import {
    logEventFloat as rumLogEventFloat,
    logEventInteger as rumLogEventInteger,
    logEventString as rumLogEventString,
} from '@ps-int/ufo-rocks/lib/helpers/rum';

import isOnPremise from './onpremise/is-onpremise';

interface LogEventOptions {
    service?: string;
    page?: string;
    additional?: Record<string, unknown>;
}

export interface LogEventStringOptions extends LogEventOptions {
    value?: string;
}

export function logEventString(name: string, options: LogEventStringOptions = {}) {
    const { value = '', ...logOptions } = options;

    if (isOnPremise) {
        return;
    }

    rumLogEventString(name, value, logOptions);
}

export function logEventInteger(name: string, value: number, options: LogEventOptions = {}) {
    if (isOnPremise) {
        return;
    }
    rumLogEventInteger(name, value, options);
}

export function logEventFloat(name: string, value: number, options: LogEventOptions = {}) {
    if (isOnPremise) {
        return;
    }
    rumLogEventFloat(name, value, options);
}
